/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popMineTask.vue?vue&type=template&id=3ba8af9d&scoped=true"
import script from "./popMineTask.vue?vue&type=script&lang=js"
export * from "./popMineTask.vue?vue&type=script&lang=js"
import style0 from "./popMineTask.vue?vue&type=style&index=0&id=3ba8af9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8af9d",
  null
  
)

export default component.exports